import PropTypes from 'prop-types';
// @flow

import React from 'react';
import _ from 'lodash';
import Switch from 'react-bootstrap-switch';

import I18n from 'PMT/i18n/I18n';

import { RouteAction } from '../../../actions';
// -- constants
import Config from 'constants/Config';
import Constants from 'constants/Constants';
import ViewConstants from 'constants/ViewConstants';
import ApiConstants from 'PMT/constants/ApiConstants';

// -- utils
import { ArrayUtils, ViewUtils, Utils } from 'PMT/utils';
import SecurityContext from 'utils/permissions/SecurityContext';
import Notify from 'PMT/utils/Notify';

// -- entities
import {
  Product,
  ProductCategory,
  RestaurantMenu,
  ProductPrices,
  Menu,
  AvailabilityDates,
  AvailabilityHours,
} from 'PMT/entities/menu';

import { OrderSettings } from 'PMT/entities/order';

// -- views
import AbstractRestaurantMenuForm from '../components/AbstractRestaurantMenuForm';
import {
  ImageDropzone,
  TextInput,
  TextInputLocalized,
  NumberInput,
} from 'PMT/components/form';
import { PricesEditor } from 'components/restaurantMenu';
import SortableList from 'PMT/components/SortableList';
import AllergenChooser from 'PMT/components/form/AllergenChooser';
import CategoryRow from './components/CategoryRow';
import MenuRow from './components/MenuRow';
import ProductOptionRow from './components/ProductOptionRow';
import ProductDetailCategoryRow from '../product/components/ProductDetailCategoryRow';
import ProductDetailMenuRow from '../product/components/ProductDetailMenuRow';
import SelectProductOptionsModal from './components/selectProductOptions/SelectProductOptionsModal';
import AvailabilityDatesForm from '../components/availabilityDates/AvailabilityDatesForm';
import AvailabilityHoursForm from '../components/availabilityHours/AvailabilityHoursForm';
import TipTooltip from 'PMT/components/TipTooltip';
import { Checkbox } from 'react-bootstrap';

export default class ProductEditView extends AbstractRestaurantMenuForm {
  static propTypes = {
    product: PropTypes.objectOf(Product).isRequired,

    restaurantMenu: PropTypes.objectOf(RestaurantMenu).isRequired,

    orderSettings: PropTypes.objectOf(OrderSettings).isRequired,

    /**
     * @param: Product
     * @param: image blob
     */
    onUpdate: PropTypes.func.isRequired,

    /**
     * @param: Product
     * @param: image blob
     */
    onCreate: PropTypes.func.isRequired,

    /**
     * @param: Product
     */
    onDelete: PropTypes.func.isRequired,

    isEditMode: PropTypes.bool.isRequired,

    currencyCode: PropTypes.string,
  };

  componentWillReceiveProps(nextProps: Object) {
    super.componentWillReceiveProps(nextProps);
  }

  shouldUpdateState(nextProps: Object) {
    return !this.props.product.equals(nextProps.product);
  }

  getDefaultState(props: Object) {
    return {
      product: props.product.copy(),

      image: null,

      validationErrors: [],

      // Modal

      displaySelectProductOptionsModal: false,
    };
  }

  get product(): Product {
    return this.state.product;
  }

  get restaurantMenu(): RestaurantMenu {
    return this.props.restaurantMenu;
  }

  isEditMode(): boolean {
    return this.props.isEditMode;
  }

  onProductChange = (product: Product) => {
    this.setState({
      product,
    });
  };

  //
  // Modal - Add Option
  //

  onDisplaySelectProductOptionsModal = (event) => {
    event.preventDefault();
    this.setState({
      displaySelectProductOptionsModal: true,
    });
  };

  onHideSelectProductOptionsModal = () => {
    this.setState({
      displaySelectProductOptionsModal: false,
    });
  };

  //
  // Events image
  //

  onImageChange = (pictureData: string) => {
    this.setState({
      image: pictureData,
    });
  };

  onDeleteProduct = (event) => {
    event.preventDefault();

    Notify.confirm(
      I18n.tr('menu.product.edit.confirm_delete_product'),
      (result) => {
        if (result) {
          this.props.onDelete(this.props.product);
        }
      }
    );
  };

  onProductChange = (product: Product) => {
    if (SecurityContext.restaurantMenu.canEdit()) {
      this.setState({
        product,
      });
    }
  };

  onNameChange = (newValue: string) => {
    const product: Product = this.product;
    product.localizedNames = newValue;
    this.onProductChange(product);
  };

  onDescriptionProductChange = (newValue: string) => {
    const product: Product = this.product;
    product.localizedDescriptions = newValue;
    this.onProductChange(product);
  };

  onPricesChange = (prices: ProductPrices) => {
    const product: Product = this.product;
    product.prices = prices;
    this.onProductChange(product);
  };

  onDisponibilityToggle = () => {
    const product: Product = this.product;
    product.toggleAvailibility();
    this.setState({
      product,
    });
  };

  onDeleteFromMenu = (menu: Menu) => {
    Notify.confirm(
      I18n.tr('menu.product.edit.confirm_delete_product_from_menu'),
      (result) => {
        if (result) {
          // TODO
        }
      }
    );
  };

  onDeleteFromCategory = (category: ProductCategory) => {
    Notify.confirm(
      I18n.tr('menu.product.edit.confirm_delete_product_from_category'),
      (result) => {
        if (result) {
          // TODO
        }
      }
    );
  };

  onDeleteProductOption = (productOption: ProductOption) => {
    Notify.confirm(
      I18n.tr('menu.product.edit.confirm_delete_option'),
      (result) => {
        if (result) {
          const product: Product = this.product;
          product.optionsIds = ArrayUtils.deleteObject(
            product.optionsIds,
            (productOptionId: string) => {
              return productOptionId === productOption.id;
            }
          );
          this.onProductChange(product);
        }
      }
    );
  };

  onSelectProductOptionss = (productOptionsList: Array<ProductOption>) => {
    const optionsIds = [];
    _.each(productOptionsList, (productOption: ProductOption) => {
      optionsIds.push(productOption.id);
    });

    const product: Product = this.product;
    product.optionsIds = optionsIds;
    this.setState({
      product,
      displaySelectProductOptionsModal: false,
    });
  };

  onProductOptionsOrderChange = (optionsIds: Array<String>) => {
    const product: Product = this.product;
    product.optionsIds = optionsIds;
    this.onProductChange(product);
  };

  onAvailibilityHoursChange = (availabilityHours: AvailabilityHours) => {
    const product: Product = this.product;
    product.availabilityHours = availabilityHours;
    this.onProductChange(product);
  };

  onToggleAvailibilityHoursChange = () => {
    const product: Product = this.product;
    if (_.isNull(product.availabilityHours)) {
      product.availabilityHours = new AvailabilityHours();
    } else {
      product.availabilityHours = null;
    }

    this.onProductChange(product);
  };

  onAvailibilityDatesChange = (availabilityDates) => {
    const product: Product = this.product;
    product.availabilityDates = availabilityDates;
    this.onProductChange(product);
  };

  onToggleAvailibilityDatesChange = () => {
    const product: Product = this.product;
    product.availabilityDates = _.isNull(product.availabilityDates)
      ? new AvailabilityDates()
      : null;
    this.onProductChange(product);
  };

  onAllergensChange = (allergens) => {
    const product: Product = this.product;
    if (!product.dietaryData) {
      product.dietaryInfo = {};
    }
    product.dietaryInfo.allergens = allergens;
    this.onProductChange(product);
  };

  onContainsAlcoholChange = () => {
    const product: Product = this.product;
    product.containsAlcohol = !product.containsAlcohol;
    this.onProductChange(product);
  };

  onChangeSequence = (value) => {
    const product: Product = this.product;
    product.defaultSequence = value;
    this.onProductChange(product);
  };

  onToggleReclaimLater = () => {
    const product: Product = this.product;
    product.reclaimLaterEnabled = !product.reclaimLaterEnabled;
    this.onProductChange(product);
  };

  //
  // Events form
  //

  onSubmit = () => {
    event.preventDefault();

    const product: Product = this.product;

    /**
     * We need to create a unique pos id if  we create a new product
     */
    if (!this.isEditMode()) {
      product.id = Utils.generateUID();

      /**
       * Activated by default.
       * @type {boolean}
       */
      //    product.activated = true;
    } else {
      product.id = this.props.product.id;
    }

    _.keys(this.product.availabilityHours).map((day) => {
      this.product.availabilityHours[
        day
      ].hours = this.product.availabilityHours[day].hours.filter(
        (hour) => !_.isNull(hour.opening) || !_.isNull(hour.closing)
      );
    });

    if (product.isValid()) {
      if (this.isEditMode()) {
        this.props.onUpdate(this.product, this.state.image);
      } else {
        this.props.onCreate(this.product, this.state.image);
      }
    } else {
      const validationErrors = product.getValidationErrors();
      this.setState({
        validationErrors,
      });
    }
  };

  onReset = () => {
    this.setState({
      product: this.props.product.copy(),
      image: null,
    });
  };

  onImageRemove = () => {
    this.props.onImageRemove(this.product);
  };

  haveModifications(): boolean {
    return (
      !this.props.product.equals(this.state.product) ||
      !_.isNull(this.state.image)
    );
  }

  shouldDisableSubmit(): boolean {
    return false;
  }

  //
  // getters
  //

  get product(): Product {
    return this.state.product;
  }

  get restaurantMenu(): RestaurantMenu {
    return this.props.restaurantMenu;
  }

  //
  // renderers
  //

  renderName() {
    return (
      <div className="form-group">
        <div className="required col-xs-4 control-label">
          <label>{I18n.tr('menu.product.edit.name')}</label>
        </div>
        <div className="col-xs-8">
          <TextInputLocalized
            locales={Constants.localesForTranslation}
            values={this.product.localizedNames}
            isRequired
            className="form-control"
            placeholder={I18n.tr('menu.product.edit.name')}
            onChange={this.onNameChange}
            readOnly={!SecurityContext.restaurantMenu.canEdit()}
          />
        </div>
        <div className="form_error col-xs-6 col-xs-offset-4">
          {this.state.validationErrors.name}
        </div>
      </div>
    );
  }

  renderDescription() {
    return (
      <div className="form-group">
        <div className="col-xs-4 control-label">
          <label>{I18n.tr('menu.product.edit.description')}</label>
        </div>
        <div className="col-xs-8">
          <TextInputLocalized
            multiLine
            locales={Constants.localesForTranslation}
            values={this.product.localizedDescriptions}
            isRequired
            className="form-control"
            placeholder={I18n.tr('menu.product.edit.description')}
            onChange={this.onDescriptionProductChange}
            readOnly={!SecurityContext.restaurantMenu.canEdit()}
          />
        </div>
        <div className="form_error col-xs-6 col-xs-offset-4">
          {this.state.validationErrors.description}
        </div>
      </div>
    );
  }

  renderImage() {
    return (
      <ImageDropzone
        editOnly={false}
        readOnly={!SecurityContext.restaurantMenu.canEdit()}
        placeholder={ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_PRODUCT}
        image={this.product.image}
        currentImage={this.state.image}
        onChange={this.onImageChange}
        onRemove={this.onImageRemove}
        aspectRatio={ApiConstants.Image.RestaurantMenu.Product.RATIO}
        width={ApiConstants.Image.RestaurantMenu.Product.WIDTH}
        height={ApiConstants.Image.RestaurantMenu.Product.HEIGHT}
        maxSize={ApiConstants.Image.RestaurantMenu.Product.MAX_SIZE}
      />
    );
  }

  renderAllergen() {
    return (
      <AllergenChooser
        allergens={
          this.product.dietaryInfo ? this.product.dietaryInfo.allergens : []
        }
        readOnly={!SecurityContext.restaurantMenu.canEdit()}
        onChange={this.onAllergensChange}
      />
    );
  }

  renderContainsAlcohol() {
    const disableModification = !SecurityContext.restaurantMenu.canEdit();

    return (
        <div className="row">
          <div className="col-xs-10 col-md-3">
            <p className="sequences_subtitle_caption">
              {I18n.tr('menu.product.edit.containsAlcohol.label')}
            </p>
          </div>
          <div className="col-xs-2">
            <Switch
                value={this.product.containsAlcohol}
                bsSize="mini"
                onChange={this.onContainsAlcoholChange}
                disabled={disableModification}
            />
          </div>
        </div>
    );
  }

  renderPrices() {
    return (
      <div className="form-group">
        <div className="col-xs-12">
          <PricesEditor
            prices={this.product.prices}
            onChange={this.onPricesChange}
            disablePriceModification={this.props.orderSettings.menuManagedByPos}
            readOnly={!SecurityContext.restaurantMenu.canEdit()}
            currencyCode={this.props.currencyCode}
          />
        </div>
        <div className="form_error col-xs-12">
          {this.state.validationErrors.prices}
        </div>
      </div>
    );
  }

  renderDeleteProduct() {
    if (this.props.orderSettings.menuManagedByPos) {
      return null;
    }

    if (!SecurityContext.restaurantMenu.canEdit()) {
      return (
        <div className="col-xs-12 text-center top-buffer-50">
          {I18n.tr('menu.product.edit.delete_product.permission_refused')}
        </div>
      );
    }

    return (
      <div className="col-xs-12 text-center top-buffer-50">
        <hr />
        {this.isEditMode() && ( // only on edit mode
          <button
            type="submit"
            className="btn btn-danger"
            onClick={this.onDeleteProduct}
          >
            {I18n.tr('menu.product.edit.delete_product')}
          </button>
        )}
      </div>
    );
  }

  renderCategoriesList() {
    const categories: Array<ProductCategory> = this.restaurantMenu.getCategoriesWithProductId(
      this.product.id
    );

    if (_.isEmpty(categories)) {
      return (
        <div>
          <div className="top-buffer-20">
            <em>{I18n.tr('menu.product.edit.no_category_with_product')}</em>
          </div>
        </div>
      );
    }

    const categoriesListView = [];

    _.each(categories, (category: ProductCategory) => {
      categoriesListView.push(
        <CategoryRow
          key={category.id}
          category={category}
          onDelete={this.onDeleteFromCategory}
        />
      );
    });

    return (
      <div>
        <ul>{categoriesListView}</ul>
      </div>
    );
  }

  renderCategoriesListRow() {
    const categories: Array<ProductCategory> = this.restaurantMenu.getCategoriesWithProductId(
      this.product.id
    );

    if (_.isEmpty(categories)) {
      return (
        <div>
          <div className="top-buffer-20">
            <em>{I18n.tr('menu.product.edit.no_category_with_product')}</em>
          </div>
        </div>
      );
    }

    const categoriesListView = [];

    _.each(categories, (category: ProductCategory) => {
      categoriesListView.push(
        <ProductDetailCategoryRow key={category.id} category={category} />
      );
    });

    return (
      <div>
        <ul>{categoriesListView}</ul>
      </div>
    );
  }

  renderMenusList() {
    const menus: Array<Menu> = this.restaurantMenu.getMenusWithProductId(
      this.product.id
    );

    if (_.isEmpty(menus)) {
      return (
        <div>
          <em>{I18n.tr('menu.product.no_menu_with_product')}</em>
        </div>
      );
    }

    const menusListView = [];

    _.each(menus, (menu: Menu) => {
      menusListView.push(<ProductDetailMenuRow key={menu.id} menu={menu} />);
    });

    return (
      <div>
        <ul>{menusListView}</ul>
      </div>
    );
  }

  renderSelectProductOptionsBtn() {
    if (!SecurityContext.restaurantMenu.canEditOptions()) {
      return null;
    }
    return (
      <button
        className="btn btn-xs"
        onClick={this.onDisplaySelectProductOptionsModal}
      >
        {I18n.tr('menu.product.edit.select_options')}
      </button>
    );
  }

  renderProductOptionRow = (optionId: string) => {
    const productOption: ProductOption = this.restaurantMenu.getProductOptionWithId(
      optionId
    );

    if (!_.isNull(productOption)) {
      return (
        <ProductOptionRow
          key={productOption.id}
          productOption={productOption}
          onDelete={this.onDeleteProductOption}
          readOnly={!SecurityContext.restaurantMenu.canEditOptions()}
        />
      );
    }
    return null;
  };

  renderProductOptionsList() {
    if (_.isEmpty(this.product.optionsIds)) {
      return (
        <div>
          {SecurityContext.restaurantMenu.canEditOptions() &&
            this.renderSelectProductOptionsBtn()}
          <div className="top-buffer-20">
            <em>{I18n.tr('menu.product.edit.no_options')}</em>
          </div>
        </div>
      );
    }

    if (!SecurityContext.restaurantMenu.canEditOptions()) {
      return (
        <ul>
          {this.product.optionsIds.map((optionId) => {
            const productOption: ProductOption = this.restaurantMenu.getProductOptionWithId(
              optionId
            );

            if (!_.isNull(productOption)) {
              return (
                <li
                  key={optionId}
                  className="pointer"
                  onClick={() => {
                    RouteAction.presentProductOptionDetail(productOption);
                  }}
                >
                  {productOption.name}
                </li>
              );
            }

            return null;
          })}
        </ul>
      );
    }

    return (
      <div>
        {this.renderSelectProductOptionsBtn()}
        <div className="table_container table_container_hover col-xs-12 top-buffer-20">
          <SortableList
            items={this.product.optionsIds}
            renderer={this.renderProductOptionRow}
            onChange={this.onProductOptionsOrderChange}
          />
        </div>
      </div>
    );
  }

  renderSelectProductOptionsModal() {
    if (!this.state.displaySelectProductOptionsModal) {
      return null;
    }

    const selectedProductOptions = this.restaurantMenu.getProductOptionsWithIds(
      this.product.optionsIds
    );

    return (
      <SelectProductOptionsModal
        restaurantMenu={this.restaurantMenu}
        show={this.state.displaySelectProductOptionsModal}
        onHide={this.onHideSelectProductOptionsModal}
        onUpdate={this.onSelectProductOptionss}
        selectedProductOptions={selectedProductOptions}
      />
    );
  }

  renderAvailibility() {
    return (
      <div>
        <hr className="col-xs-12" />
        <div className="availability_title">
          <h2 className="col-xs-12">
            {I18n.tr('menu.product_edit.product_availability')}
          </h2>
          <p className="col-xs-12 availability_intro">
            {I18n.tr('menu.product_edit.product_availability.caption')}
          </p>
        </div>
        {this.renderAvailibilityDate()}
        {this.renderAvailibilityHours()}
      </div>
    );
  }

  renderAvailibilityDate() {
    const disableModification = !SecurityContext.restaurantMenu.canEdit();

    return (
      <div>
        <div className="availability_title">
          <h4 className="col-xs-8">
            {I18n.tr('menu.product_edit.product_availability_date')}
          </h4>
          <div className="col-xs-2 top-buffer-10">
            <Switch
              value={!_.isNull(this.product.availabilityDates)}
              bsSize="mini"
              onChange={this.onToggleAvailibilityDatesChange}
              disabled={disableModification}
            />
          </div>
        </div>
        <p className="col-xs-12 availability_intro caption">
          {I18n.tr('menu.product_edit.product_availability_date.caption')}
        </p>

        {!_.isNull(this.product.availabilityDates) && (
          <AvailabilityDatesForm
            availabilityDates={this.product.availabilityDates}
            onAvailibilityDatesChange={this.onAvailibilityDatesChange}
            readOnly={!SecurityContext.restaurantMenu.canEdit()}
          />
        )}
      </div>
    );
  }

  renderAvailibilityHours() {
    const disableModification = !SecurityContext.restaurantMenu.canEdit();

    return (
      <div>
        <div className="availability_title">
          <h4 className="col-xs-8">
            {I18n.tr('menu.product_edit.product_availability_hours')}
          </h4>
          <div className="col-xs-2 top-buffer-10">
            <Switch
              value={!_.isNull(this.product.availabilityHours)}
              bsSize="mini"
              onChange={this.onToggleAvailibilityHoursChange}
              disabled={disableModification}
            />
          </div>
        </div>

        <p className="col-xs-12 availability_intro caption">
          {I18n.tr('menu.product_edit.product_availability_hours.caption')}
        </p>

        {!_.isNull(this.product.availabilityHours) && (
          <AvailabilityHoursForm
            availabilityHours={this.product.availabilityHours}
            onAvailibilityHoursChange={this.onAvailibilityHoursChange}
            readOnly={!SecurityContext.restaurantMenu.canEdit()}
          />
        )}
      </div>
    );
  }

  renderSequences() {
    const disableModification = !SecurityContext.restaurantMenu.canEdit();

    return (
      <div>
        <hr className="col-xs-12" />
        <div className="sequences_title col-xs-12">
          <h2>{I18n.tr('menu.product_edit.sequences')}</h2>
        </div>
        <div className="sequences_subtitle col-xs-12">
          <div className="row">
            <div className="col-xs-10 col-md-3">
              <p className="sequences_subtitle_caption">
                {I18n.tr('menu.product_edit.default_sequence')}
                <TipTooltip text={I18n.tr('menu.product_edit.default_sequence.tooltip')} />
              </p>
            </div>
            <div className="col-xs-2 sequences_input">
              <NumberInput
                value={this.product.defaultSequence}
                onChange={this.onChangeSequence}
                min={0}
                disabled={disableModification || this.props.orderSettings.menuManagedByPos}
              />
            </div>
          </div>
        </div>
        <div className="sequences_subtitle col-xs-12">
          <div className="row">
            <div className="col-xs-10 col-md-3">
              <p className="sequences_subtitle_caption">
                {I18n.tr('menu.product_edit.reclaim_later')}
                <TipTooltip
                  text={I18n.tr('menu.product_edit.reclaim_later.tooltip')}
                />
              </p>
            </div>
            <div className="col-xs-2">
              <Switch
                value={this.product.reclaimLaterEnabled}
                bsSize="mini"
                onChange={this.onToggleReclaimLater}
                disabled={disableModification}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    try {
      return (
        <form
          className="form form-horizontal product_edit_view"
          role="form"
          noValidate
        >
          <div className="col-xs-12">
            <div className="col-xs-12 col-md-6">
              {this.renderName()}
              {this.renderDescription()}
              <div className="col-xs-12">{this.renderImage()}</div>
            </div>
            <div className="col-xs-12 col-md-6">
              <div className="col-xs-6">
                <h2>{I18n.tr('menu.product.edit.categories')}</h2>
                {this.renderCategoriesListRow()}
              </div>
              <div className="col-xs-6">
                <h2>{I18n.tr('menu.product.edit.menus')}</h2>
                {this.renderMenusList()}
              </div>
            </div>
          </div>

          <div className="col-xs-12">
            <div className="top-buffer-40 col-sm-12">
              <h2>{I18n.tr('menu.product.edit.allergen')}</h2>
              {this.renderAllergen()}
            </div>
          </div>

          <hr />

          <div className="col-xs-12">
            <div className="top-buffer-40 col-sm-12 col-md-8">
              <h2>{I18n.tr('menu.product.edit.prices')}</h2>
              {this.renderPrices()}
            </div>

            <div className="top-buffer-40 col-sm-12 col-md-4">
              <h2>{I18n.tr('menu.product.edit.options')}</h2>
              {this.renderProductOptionsList()}
            </div>
          </div>

          <div className="row">{this.renderAvailibility()}</div>

          <div className="row">{this.renderSequences()}</div>

          <div className="row">
            <div>
              <hr className="col-xs-12"/>
              <div className="sequences_title col-xs-12">
                <h2>{I18n.tr('menu.product.edit.other')}</h2>
              </div>
              <div className="sequences_subtitle col-xs-12">
                {this.renderContainsAlcohol()}
              </div>
            </div>
          </div>

          {this.renderDeleteProduct()}

          {this.renderFixedButtons()}
          {/* Modals */}
          {this.renderSelectProductOptionsModal()}
        </form>
      );
    } catch (e) {
      console.error(e);
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/menu/productEdit/ProductEditView.js